import { Component, OnInit } from '@angular/core';
import { PER_PAGE } from '@shared/services';
import { SalesOrderService } from '@shared/services/api/sales-order.service';
import { SalesOrderFiltersService } from '@shared/services/api/sales-order-filters.service';
import { Observable, map } from 'rxjs';
import { FilterSelectedEventType } from '@shared/models/types';
import { SalesOrderFilter } from '@shared/entities/salesOrderFilter';

@Component({
  selector: 'app-repository',
  templateUrl: './repository.component.html',
  styleUrl: './repository.component.scss'
})
export class RepositoryComponent implements OnInit {
  allSalesOrders$: Observable<any[]>;
  salesOrderFilters$: Observable<SalesOrderFilter>;

  salesPrevPage?: number = undefined;
  salesNextPage?: number = undefined;
  salesCurrentPage = 1;
  salesTotalPages?: number = undefined;

  isLight = true;

  constructor(
    private _salesOrderService: SalesOrderService,
    private _salesOrderFiltersService: SalesOrderFiltersService
  ) {
    this.allSalesOrders$ = this._salesOrderService.all$.pipe(
      map((paginatedResult) => {
        this.salesCurrentPage = paginatedResult?.currentPage ?? 1;
        this.salesNextPage = paginatedResult?.nextPage ? paginatedResult.nextPage : undefined;
        this.salesPrevPage = paginatedResult?.prevPage ? paginatedResult.prevPage : undefined;
        this.salesTotalPages = paginatedResult?.totalPage ?? 1;
        return paginatedResult.data;
      })
    );

    this.salesOrderFilters$ = this._salesOrderFiltersService.all$;
  }

  ngOnInit(): void {
    this._salesOrderService.all$.subscribe({
      next: (paginatedResult) => {
        this.salesCurrentPage = paginatedResult?.currentPage ?? 1;
        this.salesNextPage = paginatedResult?.nextPage ? paginatedResult.nextPage : undefined;
        this.salesPrevPage = paginatedResult?.prevPage ? paginatedResult.prevPage : undefined;
        this.salesTotalPages = paginatedResult?.totalPage ?? 1;
      },
      error: () => {
        /* noop */
      }
    });
  }

  fetchSalesOrder() {
    this._salesOrderService.refresh({ page: 1, perPage: PER_PAGE });
  }

  onPageSelected(page: number) {
    this._salesOrderService.refresh({ page, perPage: PER_PAGE });
  }

  onFilterSelected(filters: FilterSelectedEventType[]) {
    const filtersName = filters.reduce((acc: any, filter: FilterSelectedEventType) => {
      if (filter.name === 'salesOrderNumber' || filter.name === 'keyword') {
        acc['salesOrderNumber'] = filter.selectedValue;
      } else {
        acc[filter.name] = filter.selectedValue;
      }
      return acc;
    }, {});

    this._salesOrderService.filters = filtersName;
    this._salesOrderFiltersService.filters = filtersName;
  }
}
